import {HelpFunctions} from "helpers/HelpFunctions";

export const HelpAbility = () => {
    let f = HelpFunctions();

    // Access to route
    const can = (rest) => {
        let token = localStorage.getItem('token') || null;
        if (!token) return false;

        const decoded = f.decodeToken(token);
        
        if (rest.path === '/' || !rest.abilities) return true;

        if (decoded.abilities) return rest.abilities.some(ability => decoded.abilities.includes(ability)) && rest.rol.some(ro => decoded.rol.includes(ro));

        return false;
    }

    // Access to action
    const has = (ability) => {
        let token = localStorage.getItem('token') || null;
        if (!token) return false;

        const decoded = f.decodeToken(token);

        if (decoded.abilities) return decoded.abilities.includes(ability);
        return false;
    }

    const hasAny = (abilities) => {
        let token = localStorage.getItem('token') || null;
        if (!token) return false;

        const decoded = f.decodeToken(token);

        if (decoded.abilities) return abilities.some(ability => decoded.abilities.includes(ability));
        return false;
    }

    const hasAnyStartedWith = (ability) => {
        let token = localStorage.getItem('token') || null;
        if (!token) return false;

        const decoded = f.decodeToken(token);

        if (decoded.abilities) return decoded.abilities.findIndex(a => a.substring(0, ability.length) === ability) >= 0;
        return false;
    }

    const hasRol = (rol) => {
        let token = localStorage.getItem('token') || null;
        if (!token) return false;

        const decoded = f.decodeToken(token);

        if (decoded.rol?.length) return decoded.rol.includes(rol);
        return false;
    }

    const hasAnyRol = (roles) => {
        let token = localStorage.getItem('token') || null;
        if (!token) return false;

        const decoded = f.decodeToken(token);

        if (decoded.rol) return roles.some(ro => ro = decoded.rol );
        return false;
    }

    return {can, has, hasAny, hasAnyStartedWith, hasRol, hasAnyRol};
}